import { IconDotsVertical } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";

const DeviceDonutChart = ({ chartData, loadingState }) => {

    const [series, setSeries] = useState([chartData?.desktop?.count || 0, chartData?.mobile?.count || 0, chartData?.tablet?.count || 0, chartData?.other?.count || 0]);

    useEffect(() => {
        setSeries([chartData?.desktop?.count || 0, chartData?.mobile?.count || 0, chartData?.tablet?.count || 0, chartData?.other?.count || 0])
    }, [chartData])

    const [options, setOptions] = useState({
        chart: {
            type: 'donut',
        },
        labels: ['Desktop', 'Mobile', 'Tablet', 'Other'],
        colors: ['#43E5A0', '#00A383', '#144EE3', '#144EE361', '#EB568E'],
        stroke: {
            width: 0
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        total: {
                            label: 'clicks and scans',
                            show: true,
                            color: 'var(--secondary-text)',
                            fontSize: 12,
                        },
                        value: {
                            color: 'var(--black)',
                            fontWeight: 'bold'
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: true,
            horizontalAlign: 'center', floating: true,
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: true
            },
        },
        responsive: [
            {
                breakpoint: 640,
                options: {
                    legend: {
                        floating: false,
                        position: "bottom"
                    }
                }
            }
        ]
    });

    return (
        <div className='bg-white p-1.5 rounded-xl text-white h-full'>
            <div className="flex justify-between items-center p-1 gap-2">
                <p className='mb-0 text-md font-bold text-[var(--grey)]'>Clicks & code scans by device </p>
                <div className='flex ms-auto gap-2'>
                    <button> <IconDotsVertical /> </button>
                </div>
            </div>
            <Chart options={options} series={series} height={250} type="donut" />
        </div>
    )
}

export default DeviceDonutChart;